import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const highlights = [
  {
    icon: 'Zap',
    title: 'Fast response',
    text: 'Expect a personal reply within one business day.'
  },
  {
    icon: 'Layers',
    title: 'One creative team',
    text: 'Strategy, production, and delivery under one roof.'
  },
  {
    icon: 'Shield',
    title: '30+ years trusted',
    text: 'Experienced guidance from first idea to final launch.'
  }
];

function ContactHighlights() {
  return (
    <div className="contact-highlights" aria-label="Why work with Duran Media">
      {highlights.map((item, index) => (
        <motion.div
          key={item.title}
          className="contact-highlight"
          initial={{ opacity: 0, x: -24 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5 + index * 0.1 }}
        >
          <span className="contact-highlight-icon" aria-hidden="true">
            <SafeIcon name={item.icon} focusable="false" />
          </span>
          <span>
            <strong>{item.title}</strong>
            <small>{item.text}</small>
          </span>
        </motion.div>
      ))}
    </div>
  );
}

export default ContactHighlights;